import styled from "styled-components";

import color from "../../constants/color";
import materialUI from "../../material-UI";

export const HomeContainer = styled.div`
  margin: 66px 33px 0px 33px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background: linear-gradient(
    268.28deg,
    rgba(6, 217, 134, 0.3) 0%,
    rgba(74, 118, 251, 0.3) 100%
  );
  border-radius: 16px 16px 0px 0px;
  padding: 33px;
  margin: 0px 33px;
`;

export const WelcomeText = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  color: ${color.grey1};
  display: flex;
  align-items: center;
  span {
    color: ${color.Info};

    &.exclamation {
      color: ${color.primary};
    }
  }
`;

export const Notification = styled.div`
  width: 40px;
  height: 40px;
  background: ${color.White};
  box-shadow: 0px 4px 4px rgba(102, 102, 102, 0.2);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

export const NotificationCounter = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background: ${color.error};
  color: ${color.White};
  font-family: Inter;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -3px;
  right: -3px;
`;

export const SectionContent = styled.div`
  width: 100%;
`;

export const ContentContainer = styled.div`
  background: ${color.White};
  border-radius: 16px;
  padding: 16px 32px;
  display: flex;
  justify-content: space-between;
`;

export const Shortcuts = styled.div`
  border: 1px solid ${color.cardBorder};
  border-radius: 8px;
  position: relative;
  padding: 32px 32px 10px 32px;

  img {
    width: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    border-radius: 8px;
    max-height: 163px;

    &.bullets-bg {
      top: 26px;
      right: 26px;
      width: auto;
      left: unset;
    }
  }

  .swiper {
    .swiper-wrapper {
    }
    .swiper-slide {
      width: 100%;
      max-width: 238px;

      @media (max-width: 1330px) {
        max-width: calc(33% - 8px);
      }
    }
    .swiper-pagination {
      position: relative;
      margin-top: 15px;
      align-items: center;
      display: flex;
      justify-content: center;

      .swiper-pagination-bullet {
        width: 4px;
        height: 4px;
        margin: 0px 2px;
      }

      .swiper-pagination-bullet-active {
        width: 8px;
        height: 8px;
        background: ${color.primary};
      }
    }
  }
`;

export const ShortcutsTitle = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  color: ${color.fullBlack};
  margin-bottom: 32px;
  z-index: 1;
  position: relative;

  &.titleBday {
    margin-bottom: 16px;
  }
`;

export const IndicatorsHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 8px;
  width: 100%;
  margin-bottom: 32px;
`;

export const IndicatorsTitle = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  color: ${color.fullBlack};
  margin: 0;
  flex: 0 1 auto;
  min-width: 0;
`;

export const AtualizarIndicadoresBtn = styled.button`
  height: 37px;
  align-items: center;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #2d5bff;
  background-color: #eaefff;
  display: flex;
  border-radius: 0.25rem;
  padding: 14px;
  gap: 0.5rem;
  white-space: nowrap;
  flex-shrink: 0;
  :hover {
    cursor: pointer;
  }
`;

export const IndicatorsActionsContainer = styled.div`
  display: flex;
  flex: 1 1 560px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
`;

export const IndicatorsButtonsGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
`;

export const GerenteOnlineBadge = styled.div<{ $withAutoMargin?: boolean }>`
  height: 37px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: ${({ $withAutoMargin }) => ($withAutoMargin ? "auto" : "0")};
  padding: 0 14px;
  border-radius: 0.25rem;
  background-color: #ffffff;
  border: 1px solid #eaecf0;
  color: #344054;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
  flex-shrink: 0;

  @media (max-width: 640px) {
    flex-basis: ${({ $withAutoMargin }) => ($withAutoMargin ? "100%" : "auto")};
    margin-left: 0;
    justify-content: ${({ $withAutoMargin }) =>
      $withAutoMargin ? "flex-end" : "flex-start"};
  }
`;

export const GerenteOnlineBadgeIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  &.notifications-header {
    margin-bottom: 32px;
  }

  &.row-text {
    justify-content: space-between;
  }
`;
export const ContactText = styled.a`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  letter-spacing: -0.01em;
  color: ${color.grey3};
  margin-top: 10px;
  display: flex;
  align-items: center;
  text-decoration: none;

  svg {
    margin-right: 8px;
  }

  img {
    height: 16px;
    width: 100%;
    margin-right: 8px;
  }
`;

export const ShortcutCard = styled.a`
  background: ${color.White};
  box-shadow: 0px 2px 2px rgba(102, 102, 102, 0.2);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  height: 150px;
  z-index: 1;
  position: relative;
  width: 100%;
  max-width: 238px;
`;

export const CardText = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.01em;
  color: ${color.grey1};
  margin-top: 24px;
`;

export const Indicators = styled.div`
  padding: 0 0px 32px 0;
`;

export const RowIndicators = styled.div`
  display: flex;
  justify-content: space-between;
`;

// Linha de cards de agendamento: distribui igualmente N cards (3 ou 4) com gap,
// sobrescrevendo a largura fixa de 33.3% do CardIndicator.
export const RowIndicatorsAgendamento = styled.div`
  display: flex;
  gap: 10px;

  & > div {
    flex: 1;
    width: auto;
    min-width: 0;
  }
`;

export const Tabs = styled(materialUI.Tabs)`
  color: ${color.almostBlack};
  font-family: Inter;
  background-color: ${color.white};
  border-top-right-radius: 8px;
  border-bottom: 1px solid #d2d8e8;
  border-top-left-radius: 8px;
  width: 100%;
`;
export const Tab = styled(materialUI.Tab)`
  font-family: Inter-Medium;
  height: 54px;
  color: ${color.Almostblack};
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.015em;
  padding: 16px 32px;
  flex: 1;
  width: auto;
  min-width: 0;
  max-width: unset;
  opacity: 1;

  &.task-tab {
    flex: unset;
    width: 50%;
  }

  &.MuiTab-textColorInherit.Mui-selected {
    color: ${color.primary};
  }
`;
export const Box = styled(materialUI.Box)``;
export const CardIndicator = styled.div`
  margin-top: 16px;
  padding: 16px 24px;
  gap: 10px;
  width: calc(33.3% - 7px);
  min-height: 117px;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.1s;

  &:hover {
    transform: scale(1.02);
  }

  @media (max-width: 1280px) {
    padding: 14px 16px;
  }

  @media (max-width: 1024px) {
    padding: 12px;
  }
`;

export const TextNumber = styled.p`
  color: ${(props) => props.color};
  margin-top: 6px;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
`;

export const NumberRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PercentBadge = styled.span<{ color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  background: ${(props) => props.color};
  color: #ffffff;
  font-family: Inter;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
`;

export const TextStatus = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 8px;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;

  @media (max-width: 1280px) {
    font-size: 13px;
  }

  @media (max-width: 1024px) {
    font-size: 12px;
    line-height: 130%;
  }

  /* Texto curto (mobile/telas estreitas) fica escondido por padrão. */
  .label-short {
    display: none;
  }

  @media (max-width: 900px) {
    .label-full {
      display: none;
    }
    .label-short {
      display: inline;
    }
  }
`;

export const SectionTasks = styled.div`
  width: 33.3%;
  margin-left: 32px;
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 16px;
`;

export const HeaderTasks = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const TasksTitle = styled.p`
  font-family: Inter-Medium;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: ${color.gray900};
  margin-left: 20px;
`;

export const Button = styled(materialUI.Button)`
  width: 170px;
  height: 43px;
  border-radius: 8px;
  border: 1px solid ${color.Mediumgrey};
  &.plus-btn {
    min-width: 40px;
    width: 40px;
    height: 40px;
    background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
    border-radius: 8px;
    border: none;
  }
  .MuiCircularProgress-root {
    width: 20px !important;
    height: 20px !important;
    color: ${color.white};
  }
`;
export const FilterTasks = styled(materialUI.Button)`
  width: 50%;
  font-family: Inter-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.01em;
  color: ${color.black};
  text-transform: capitalize;
  height: 40px;
  border-radius: 8px;
  position: relative;
  transition: all 0.3s;
  border: 1px solid ${color.cardBorder};

  &.filter-active {
    background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
    color: ${color.White};
    border: none;
  }

  &.filter-left {
    border-radius: 8px 0px 0px 8px;
    border-right: none;
    position: relative;

    &:before {
      content: "";
      position: absolute;
      top: -1px;
      right: -5px;
      height: 1px;
      width: 100%;
      background: ${color.cardBorder};
    }

    &:after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: -5px;
      height: 1px;
      width: 100%;
      background: ${color.cardBorder};
    }
  }
  &.filter-right {
    border-radius: 0px 8px 8px 0px;
    border-left: none;

    &:before {
      content: "";
      position: absolute;
      top: -1px;
      left: -5px;
      height: 1px;
      width: 100%;
      background: ${color.cardBorder};
    }

    &:after {
      content: "";
      position: absolute;
      bottom: -1px;
      left: -5px;
      height: 1px;
      width: 100%;
      background: ${color.cardBorder};
    }
  }
`;

export const ContentTarefas = styled.div`
  overflow-x: auto;
  height: 600px;
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: ${color.LigthGrey};
  }
`;

export const LoadingTasks = styled(materialUI.CircularProgress)`
  display: block;
  margin: 0 auto;
  margin-top: 50px;
  color: ${color.primary};
  width: 25px !important;
  height: 25px !important;
`;

export const Text = styled.div`
  font-family: Inter;
  font-size: 14px;
  color: ${color.grey9};
  margin: 8px 0px -4px 8px;
`;

export const BlankIcon = styled.span`
  position: absolute;
  right: 16px;
  top: 16px;
`;

export const BirthdaysRow = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const CardBirthday = styled.a`
  width: calc(50% - 8px);
  background: rgba(33, 150, 243, 0.2);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  margin-bottom: 16px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.1s;
  text-decoration: none;

  &:hover {
    transform: scale(1.02);
  }
`;

export const HeaderCardBD = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 9px;
`;

export const TitleBday = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.01em;
  color: ${color.Info};
`;

export const TextCardBD = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.01em;
  color: #3f3f3f;
`;

export const ModalNotifications = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transition: all 0.3s;
  visibility: hidden;
  opacity: 0;
  top: 0;
  left: 0;
  z-index: 9999;
  &.open-true {
    visibility: visible;
    opacity: 1;
  }
`;

export const ModalBG = styled.div`
  width: 100%;
  height: 100%;
`;

export const ModalContent: any = styled.div`
  width: 372px;
  max-height: 742px;
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(102, 102, 102, 0.2);
  border-radius: 16px;
  position: absolute;
  z-index: 99999;
  right: 65px;
  top: ${(props: any) => props.top}vw !important;
  padding: 32px 16px;
`;

export const NotificationsTitleModal = styled.div`
  font-family: Inter-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: ${color.gray900};
  margin-left: 20px;
`;

export const NotificationsList = styled.div`
  overflow-y: auto;
  max-height: 600px;
  min-height: 350px;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: ${color.LigthGrey};
  }
`;

export const CardsType = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.01em;
  color: ${color.black};
  margin: 16px 0px;
`;

export const CardNotifications = styled.a`
  width: 98%;
  margin: 0 auto;
  background: rgba(33, 150, 243, 0.2);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  margin-bottom: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.1s;
  text-decoration: none;
  display: block;

  &:hover {
    transform: scale(1.02);
  }

  &.card-read {
    background: ${color.gray100};
  }
`;

export const HeaderCardNotifications = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleHeaderCardNotifications = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.01em;
  color: ${color.Info};

  &.card-read {
    color: ${color.black};
  }
`;

export const DateHeaderCardNotifications = styled.p`
  font-family: Inter-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: flex-end;
  text-align: right;
  letter-spacing: -0.02em;
  color: #3f3f3f;
  opacity: 0.5;
`;

export const ContentNotifications = styled.div`
  font-family: Inter-Medium;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.01em;
  color: #3f3f3f;
  margin-top: 8px;
`;

export const NotificationsMessage = styled.div``;

export const NotDefined = styled.div`
  width: 100%;
  margin-top: 16px;
  background: rgba(237, 108, 2, 0.2);
  border-radius: 8px;
  padding: 16px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  display: flex;
  align-items: center;

  .icon-alert {
    margin-right: 13px;
  }
`;
